import React, { useState, ChangeEvent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "../../../utils/Hooks";
import {useNavigate, useParams} from "react-router-dom";
import { getUsers } from "../../../store/reducers/UsersSlice";
import { Option } from "../../common/form/ElogSelect";
import { getEmails } from "../../../store/reducers/EmailsSlice";
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';

const EmailsSearch: React.FC = () => {
    const dispatch = useAppDispatch();
    const routeParams = useParams();
    const navigate = useNavigate();

    const usersState = useAppSelector((state) => state.users);

    const [fromDate, setFromDate] = useState<Date | null>(null);
    const [toDate, setToDate] = useState<Date | null>(null);
    const [user, setUser] = useState<string>('');

    useEffect(() => {

        dispatch(getUsers());

        const urlParams = new URLSearchParams(window.location.search);

        const from = urlParams.get("fromDate");
        const to = urlParams.get("toDate");
        const userParam = urlParams.get("user");

        if (from && dayjs(from, 'DD.MM.YYYY').isValid()) {
            setFromDate(dayjs(from, 'DD.MM.YYYY').toDate());
        } else {
            setFromDate(null);
        }

        if (to && dayjs(to, 'DD.MM.YYYY').isValid()) {
            setToDate(dayjs(to, 'DD.MM.YYYY').toDate());
        } else {
            setToDate(null);
        }

        setUser(userParam || '');

        const page = parseInt(urlParams.get("p") as string, 10) || 1;

        dispatch(getEmails({
            user: userParam || '',
            timeFrom: from || '',
            timeTo: to || '',
            page,
            perPage: 30
        }));
    }, [routeParams, window.location.search]);

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();

        const searchParams = new URLSearchParams();

        if (fromDate) {
            searchParams.set("fromDate", dayjs(fromDate).format('DD.MM.YYYY'));
        }
        if (toDate) {
            searchParams.set("toDate", dayjs(toDate).format('DD.MM.YYYY'));
        }
        searchParams.set("user", user);

        const newUrl = `/emails?${searchParams.toString()}`;
        navigate(newUrl);
    };

    const userOptions: Option[] = usersState.users
        .filter((user) => user.logistician === 1)
        .map((user) => ({
            value: user.id.toString(),
            label: `${user.firstname} ${user.lastname}`,
        }));

    return (
        <form onSubmit={handleSearch}>
            <input type="hidden" name="page" value="emails" />
            <div className="filter clear" style={{ width: '99%' }}>
                <div className="content" style={{ width: '100%' }}>
                    <p>
                        <span style={{ display: 'inline-flex' }}>
                            <label><strong>Periood:</strong></label>
                            <DatePicker
                                selected={fromDate}
                                onChange={(date: Date | null) => setFromDate(date)}
                                dateFormat='dd.MM.yyyy'
                                className='date'
                                locale="et"
                                showYearDropdown
                                showMonthDropdown
                            />
                            –
                            <DatePicker
                                selected={toDate}
                                onChange={(date: Date | null) => setToDate(date)}
                                dateFormat='dd.MM.yyyy'
                                className='date'
                                locale="et"
                                showYearDropdown
                                showMonthDropdown
                            />
                        </span>
                        &nbsp;&nbsp;&nbsp;
                        <label><strong>Logistik:</strong></label>
                        <select
                            name="user"
                            className="w150"
                            value={user}
                            onChange={(e: ChangeEvent<HTMLSelectElement>) => setUser(e.target.value)}
                        >
                            <option value="-1">Kõik</option>
                            {userOptions.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </p>
                </div>
                <p className="action">
                    <button type="submit"><span><strong>Otsi</strong></span></button>
                </p>
            </div>
        </form>
    );
};

export default EmailsSearch;